module.exports = "https://img1.huilianyi.com/9/corp-payment@3x.9be6b5092b.appcore.png";